//@flow
/**
 * These functions are used for adding shapes to and working with SVGs.
 * @module utils/svg
 */

import { getBase64FromExternalImage } from 'utils/image';

export * from './generateLearnerGraph';
export * from './generateLearnerAnalysisGraph';
export * from './generateDlrqSuitabilityGraph';
export * from './generateDlrqFocusAreaGraph';

/**
 * Creates a dataURI for the svg passed in.
 * @memberof utils/svg
 */
export async function svgToDataUri(svgEle) {
    let DOMURL = window.URL || window.webkitURL || window,
        svg = new Blob([svgEle.outerHTML], { type: 'image/svg+xml;charset=utf-8' });

    return await getBase64FromExternalImage(DOMURL.createObjectURL(svg));
}

/**
 * Creates a PNG of the svg passed in using the canvas API and returns the data URI.
 * @memberof utils/svg
 */
export async function svgToPng(svg, width, height) {
    return new Promise((resolve, reject) => {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');

        let img = document.createElement('img');

        img.onload = () => {
            if (ctx == null) {
                return reject(new Error('Failed to get canvas context.'));
            }
            width = width || img.naturalWidth;
            height = height || img.naturalHeight;
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL('image/png'));
        };

        img.setAttribute('src', svg);
    });
}

/**
 * Creates a circle SVG element and appends it as a child to the svg element passed in.
 * @memberof utils/svg
 */
export function addCircle(svg, r, cx, cy, isHollow) {
    let circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');

    circle.setAttribute('r', r);
    circle.setAttribute('cx', cx);
    circle.setAttribute('cy', cy);

    if (isHollow) {
        circle.setAttribute('fill', 'none');
        circle.setAttribute('stroke', 'black');
        circle.setAttribute('stroke-width', '3');
    }

    svg.appendChild(circle);
    return circle;
}

/**
 * Creates a line SVG element and appends it as a child to the svg passed in.
 * @memberof utils/svg
 */
export function addLine(svg, x1, y1, x2, y2, width = '2') {
    let line = document.createElementNS('http://www.w3.org/2000/svg', 'line');

    line.setAttribute('x1', x1);
    line.setAttribute('y1', y1);
    line.setAttribute('x2', x2);
    line.setAttribute('y2', y2);
    line.setAttribute('stroke-width', width);

    svg.appendChild(line);
    return line;
}

/**
 * Creates a rect SVG element and appends it as a child to the svg passed in.
 * @memberof utils/svg
 */
export function addRectangle(svg, x, y, width, height, color) {
    let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

    // console.log("x " + x)
    // console.log("y " + y)
    // console.log("width " + width)
    // console.log("height " + height)

    rect.setAttribute('x', x);
    rect.setAttribute('y', y);
    rect.setAttribute('width', width);
    rect.setAttribute('height', height);
    rect.setAttribute('fill', color);

    svg.appendChild(rect);
    return rect;
}
